<script setup lang="ts">
const { t } = useI18n();
</script>

<template>
  <div class="rating-tooltip-content">
    <div class="rating-tooltip-content__inner">
      <div class="rating-tooltip-content__text">
        <strong>{{ $t('components.ratingTooltip.title') }}</strong> — {{ $t('components.ratingTooltip.description') }}:
      </div>
      <div class="rating-tooltip-content__text">
        {{ $t('components.ratingTooltip.calculation') }}
      </div>
    </div>

    <div class="rating-tooltip-content__list">
      <div class="rating-tooltip-content__item">
        <div class="rating-tooltip-content__text">
          🌐 <strong>{{ $t('components.ratingTooltip.proxyType.title') }}</strong>
        </div>
        <div class="rating-tooltip-content__description">
          {{ $t('components.ratingTooltip.proxyType.description') }}
        </div>
        <div>
          <div>
            • <span class="rating-tooltip-content__text sm">{{ $t('components.ratingTooltip.proxyType.mobile') }}</span> <span class="rating-tooltip-content__description">- {{ $t('components.ratingTooltip.proxyType.mobileDesc') }}</span>
          </div>
          <div>
            • <span class="rating-tooltip-content__text sm">{{ $t('components.ratingTooltip.proxyType.resident') }}</span> <span class="rating-tooltip-content__description">- {{ $t('components.ratingTooltip.proxyType.residentDesc') }}</span>
          </div>
          <div>
            • <span class="rating-tooltip-content__text sm">{{ $t('components.ratingTooltip.proxyType.corporate') }}</span> <span class="rating-tooltip-content__description">- {{ $t('components.ratingTooltip.proxyType.corporateDesc') }}</span>
          </div>
        </div>
      </div>

      <div class="rating-tooltip-content__item">
        <div class="rating-tooltip-content__text">
          🚫 <strong>{{ $t('components.ratingTooltip.blacklists.title') }}</strong>
        </div>
        <div class="rating-tooltip-content__description">
          {{ $t('components.ratingTooltip.blacklists.description') }}.
        </div>
        <div>
          <div>
            • <span class="rating-tooltip-content__description">{{ $t('components.ratingTooltip.blacklists.penalty') }}</span>.
          </div>
          <div>
            • <span class="rating-tooltip-content__description">{{ $t('components.ratingTooltip.blacklists.maxPenalty') }}</span>.
          </div>
        </div>
      </div>

      <div class="rating-tooltip-content__item">
        <div class="rating-tooltip-content__text">
          🔗 <strong>{{ $t('components.ratingTooltip.siteAvailability.title') }}</strong>
        </div>
        <div class="rating-tooltip-content__description">
          {{ $t('components.ratingTooltip.siteAvailability.description') }}:
        </div>
        <div>
          <div>
            • <span class="rating-tooltip-content__description">{{ $t('components.ratingTooltip.siteAvailability.penalty') }}</span>.
          </div>
          <div>
            • <span class="rating-tooltip-content__description">{{ $t('components.ratingTooltip.siteAvailability.maxPenalty') }}</span>.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.rating-tooltip-content {
  font-family: Roboto, sans-serif;
  min-height: 400px;
  &__list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  &__item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    border: 1px solid #5D5D5D;
    border-radius: 12px;
    padding: 12px;
  }
  &__text {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0;
    &.sm {
      font-size: 12px;
    }
  }
  &__subtext {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0;
  }
  &__inner {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
  }
  &__description {
    font-weight: 300;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0;
    color: #A4A5B1
  }
}
</style>